import { useEffect } from 'react';

import {
  useExternalJobBoardsState,
  useExternalJobBoardsActions
} from './ExternalJobBoardsContext';

import {
  getExternalJobBoards,
} from './restApi';

const ExternalJobBoardsLoader = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { initializeState, onResponse, onError } = useExternalJobBoardsActions();

  useEffect(() => {
    initializeState();
  }, []);

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page'), 10);
    const initialPageNumber = page > 0 ? page : 1;

    getExternalJobBoards({
      onResponse,
      onError,
      body: {
        authenticityToken,
        pageNumber: initialPageNumber,
      },
    });
  }, []);

  useEffect(() => {
    if (externalJobBoardsState?.pageNumber) {
      const url = new URL(window.location);
      url.searchParams.set('page', externalJobBoardsState.pageNumber);
      window.history.replaceState({}, '', url);
    }
  }, [externalJobBoardsState?.pageNumber]);

  return null;
};

export default ExternalJobBoardsLoader;
